var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"layout-header"},[_c('div',{staticClass:"layout-header__navbar"},[_c('main-navbar',{attrs:{"title":_vm.title}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }